import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

export const exportFile = (filename, exportData, Heading) => {
    /* convert state to workbook */

    if (exportData && exportData.length) {
        let exportDataTemp = exportData.map(item => Object.values(item));

        const ws = XLSX.utils.json_to_sheet(exportDataTemp, { origin: 'A2', skipHeader: true });//XLSX.utils.aoa_to_sheet(exportDataTemp);
        const wb = XLSX.utils.book_new();
        XLSX.utils.sheet_add_aoa(ws, [Heading], { origin: 'A1' });
        XLSX.utils.book_append_sheet(wb, ws, filename);
        XLSX.utils.sheet_to_csv(ws, { FS: "\t" });
        /* generate XLSX file and send to client */
        XLSX.writeFile(wb, filename + ".csv", { bookType: 'csv', type: 'buffer' });
    }

}

export const exportPDF = (filename, headers, exportData) => {
    const doc = new jsPDF();
    autoTable(doc, {
        head: [headers],
        body: exportData,
    })

    doc.save(filename)
}